import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import { TourProvider } from "./components/GuidedTour";

import Landing from "./pages/Landing";
import AppChooser from "./pages/AppChooser";
import Login from "./pages/Login";
import AcceptInvite from "./pages/AcceptInvite";
import LinkGraph from "./pages/LinkGraph";
import Dashboard from "./pages/Dashboard";
import SystemDetail from "./pages/SystemDetail";
import SopLibrary from "./pages/SopLibrary";
import FindingsLibrary from "./pages/FindingsLibrary";
import Settings from "./pages/Settings";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import Terms from "./pages/legal/Terms";
import DPA from "./pages/legal/DPA";
import IcfExtract from "./pages/icf/IcfExtract";
import IcfExecute from "./pages/icf/IcfExecute";
import IcfExplain from "./pages/icf/IcfExplain";
import StoryCover from "./pages/icf/story/StoryCover";
import StorySetup from "./pages/icf/story/StorySetup";
import StoryAmendment from "./pages/icf/story/StoryAmendment";
import StoryPunchline from "./pages/icf/story/StoryPunchline";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <TourProvider>
                        <Routes>
                            <Route path="/" element={<AppChooser />} />
                            <Route path="/gxp" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Navigate to="/" replace />} />
                            <Route path="/forgot-password" element={<Navigate to="/" replace />} />
                            <Route path="/reset-password" element={<Navigate to="/" replace />} />
                            <Route path="/accept-invite" element={<AcceptInvite />} />
                            <Route path="/legal/privacy" element={<PrivacyPolicy />} />
                            <Route path="/legal/terms" element={<Terms />} />
                            <Route path="/legal/dpa" element={<DPA />} />

                            <Route path="/icf" element={<Navigate to="/icf/story" replace />} />
                            <Route
                                path="/icf/story"
                                element={
                                    <ProtectedRoute>
                                        <StoryCover />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/icf/story/setup"
                                element={
                                    <ProtectedRoute>
                                        <StorySetup />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/icf/story/amendment"
                                element={
                                    <ProtectedRoute>
                                        <StoryAmendment />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/icf/story/punchline"
                                element={
                                    <ProtectedRoute>
                                        <StoryPunchline />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/icf/extract"
                                element={
                                    <ProtectedRoute>
                                        <IcfExtract />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/icf/execute"
                                element={
                                    <ProtectedRoute>
                                        <IcfExecute />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/icf/explain"
                                element={
                                    <ProtectedRoute>
                                        <IcfExplain />
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/systems/:id"
                                element={
                                    <ProtectedRoute>
                                        <SystemDetail />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/sops"
                                element={
                                    <ProtectedRoute>
                                        <SopLibrary />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/findings"
                                element={
                                    <ProtectedRoute>
                                        <FindingsLibrary />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/link-graph"
                                element={
                                    <ProtectedRoute>
                                        <LinkGraph />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/settings"
                                element={
                                    <ProtectedRoute>
                                        <Settings />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/systems"
                                element={<Navigate to="/dashboard" replace />}
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </TourProvider>
                </BrowserRouter>
            </AuthProvider>
            <Toaster
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#0a0a0a",
                        color: "#fff",
                        border: "1px solid #262626",
                        borderRadius: "4px",
                        fontFamily: "IBM Plex Sans, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
